import { getWaitActionSupportedTimeUnits } from "../timeUnits";
import { ISelectOption } from "./selectOption.interface";

export const WaitActionSupportedTimeUnitsOptions: ISelectOption[] = getWaitActionSupportedTimeUnits().map(
    (unit) => ({ id: unit, value: unit, displayName: unit }) as ISelectOption,
);
